import { mediaQueryUp } from 'components/utils/breakpoint'
import { css } from 'styled-components'
import config from 'constants/config'
import { generateCSSVarEntries, themeClassName } from 'lib/theme/themeUtils'

const DefaultStyle = css(Object.fromEntries(generateCSSVarEntries(config.theme.defaultPalette, 'palette')))
const InverseStyle = css(Object.fromEntries(generateCSSVarEntries(config.theme.inversePalette, 'palette')))

const ThemeStyles = css`
  :root,
  .${themeClassName('default')} {
    ${DefaultStyle}
  }
  .${themeClassName('inverse')} {
    ${InverseStyle}
  }
  ${mediaQueryUp.tablet} {
    .${themeClassName({ tabletAndUp: 'default' })} {
      ${DefaultStyle}
    }
    .${themeClassName({ tabletAndUp: 'inverse' })} {
      ${InverseStyle}
    }
  }
  ${mediaQueryUp.desktop} {
    .${themeClassName({ desktopAndUp: 'default' })} {
      ${DefaultStyle}
    }
    .${themeClassName({ desktopAndUp: 'inverse' })} {
      ${InverseStyle}
    }
  }
`

export default ThemeStyles
